/** There is no photo column on any person table, so the avatar is initials, tinted by team so one team reads as one colour. */

import { personName, type DirectoryEntry } from '../lib/hr'
import { initialsOf } from '../lib/orgTree'

const AVATAR_TONES = [
  'bg-sky-100 text-sky-800 dark:bg-sky-900/60 dark:text-sky-200',
  'bg-violet-100 text-violet-800 dark:bg-violet-900/60 dark:text-violet-200',
  'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/60 dark:text-emerald-200',
  'bg-amber-100 text-amber-900 dark:bg-amber-900/60 dark:text-amber-200',
  'bg-rose-100 text-rose-800 dark:bg-rose-900/60 dark:text-rose-200',
  'bg-teal-100 text-teal-800 dark:bg-teal-900/60 dark:text-teal-200',
  'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/60 dark:text-indigo-200',
  'bg-lime-100 text-lime-900 dark:bg-lime-900/60 dark:text-lime-200',
] as const

function avatarTone(team: string): string {
  let h = 0
  for (const ch of team) h = (h * 31 + ch.charCodeAt(0)) >>> 0
  return AVATAR_TONES[h % AVATAR_TONES.length]!
}

export function Avatar({ person, size = 'md' }: { person: DirectoryEntry; size?: 'sm' | 'md' }) {
  return (
    <span
      aria-hidden
      className={`inline-flex shrink-0 items-center justify-center rounded-full font-semibold ${
        size === 'sm' ? 'h-7 w-7 text-[11px]' : 'h-9 w-9 text-xs'
      } ${avatarTone(person.team)}`}
    >
      {initialsOf(personName(person))}
    </span>
  )
}

export function positionFor(person: DirectoryEntry, language: string): string {
  if (language.startsWith('mn') && person.position_mn) return person.position_mn
  return person.position || person.position_mn
}
